<template>
  <el-select
    v-model="value"
    @change="change"
    :disabled="disabled"
    clearable
    filterable

    placeholder="渠道应用">
    <el-option
      v-for="item in list"
      :label="item.appName"
      :value="item.appId"
      :key="item.appId" />
  </el-select>
</template>

<script>
import { findItem } from '@/util'
import { hot } from '@/api/hot'
import { getChannelAppName } from '@/api/select'

export default {
  props: ['modelValue', 'disabled', 'channelId'],
  emits: ['update:modelValue', 'change', 'change-item'],
  data () {
    return {
      value: this.modelValue,
      list: []
    }
  },
  watch: {
    modelValue (newVal) {
      if (this.value === newVal) return
      this.value = newVal
      this.change(newVal)
    },
    channelId () {
      if (this.channelId) {
        this.getChannelAppName({ channelId: this.channelId })
      }
    }
  },
  created () {
    this.getChannelAppName()
  },
  methods: {
    getChannelAppName (param) {
      getChannelAppName(param).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.list = res.data
          }
          if (this.value) { // 初始值undefined的bug
            this.$emit('change-item', findItem(this.list, this.value, 'appId'))
          }
        }
      })
    },
    change (item) {
      const data = {
        maker: 'appInfoOnThe',
        onTheOrderId: item
      }
      hot(data)
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
      this.$emit('change-item', findItem(this.list, item, 'appId')) // 返回 整个选中对象
    }
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>

<style scoped>

</style>
